import { TFunction } from 'react-i18next';

import { TestStrategy } from 'modules/experiments/types';
import { ScheduleType } from 'modules/domains/campaign';
import { baseColors } from 'ui/theme';

export const getRadioFieldOptions = (t: TFunction, scheduleType: ScheduleType) => {
  const isCampaignScheduledForRecipientTimeZone = scheduleType === ScheduleType.RecipientTimeZone;

  return [
    {
      id: TestStrategy.ALL_USERS,
      name: t('settings.audienceSettings.testAllUsers'),
      value: TestStrategy.ALL_USERS,
    },
    {
      id: TestStrategy.SUBSET_USERS,
      name: t('settings.audienceSettings.testSubsetOfUsers'),
      value: TestStrategy.SUBSET_USERS,
      isHelperIconEnabled: true,
      helperIconContent: t('settings.subsetUsersTooltip'),
      helperIconProps: { color: baseColors.grey50 },
      ...(isCampaignScheduledForRecipientTimeZone && {
        isDisabled: true,
        isTooltipEnabled: true,
        tooltipContent: t('settings.audienceSettings.campaignSchedulerType'),
      }),
    },
  ];
};
